import { gql } from 'apollo-boost'

const UPDATE_MENU_SCRAPING_TEMPLATE = gql`
  mutation updateMenuScrapingTemplate(
    $id: ID!
    $data: UpdateMenuScrapingTemplateInput!
  ) {
    updateMenuScrapingTemplate(id: $id, data: $data) {
      id
    }
  }
`

export default UPDATE_MENU_SCRAPING_TEMPLATE
